@if (dataVisible$ | async) {
    @if (heeftVerdeling) {

        <p class="pb-2" style="width: 75%">
            <snelstart-ui-alert [showIcon]="true" type="info">
                Verdeel onderstaand de gezamenlijke posten door in de kolom 'Aangever toegepast' de verdeelpost(en) in te vullen of aan te passen. Het aandeel van de partner wordt automatisch berekend.
            </snelstart-ui-alert>
        </p>

        @if (formGroup.controls.totaalTeVerdelen.controls.totaalEigenWoning.value ?? 0 !== 0) {
            <div class="pt-0.5 row">
                <form [formGroup]="formGroup" class="d-contents">
                    <div class="pe-2 ps-1" style="width: 300px; text-align: start">
                        <p [class]="eersteVerdeelpost == 1 ? 'pt-3' : ''">
                            Inkomsten uit eigen woning
                        </p>
                    </div>
                    <div class="pe-4" formGroupName="totaalTeVerdelen" style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                [label]="eersteVerdeelpost === 1 ? 'Totaal' : ''"
                                align="right"
                                class="me-1 custom-input-125"
                                formControlName="totaalEigenWoning"
                                id="totaalEigenWoning"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="pe-3" formGroupName="gekozenAangever" style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [label]="eersteVerdeelpost === 1 ? 'Aangever toegepast' : ''"
                                [maxValue]="maxValueEw"
                                [minValue]="minValueEw"
                                align="right"
                                class="custom-input-125"
                                formControlName="aandeelEigenWoning"
                                id="aandeelEigenWoningGA"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="pe-5" formGroupName="gekozenPartner" style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [calculate]="getPartnerDeelEw()"
                                [decimals]="0"
                                [disabledControl]="true"
                                [label]="eersteVerdeelpost === 1 ? 'Partner toegepast' : ''"
                                align="right"
                                class="me-1 custom-input-125"
                                formControlName="aandeelEigenWoning"
                                id="aandeelEigenWoningGP"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="ps-5 pe-3" formGroupName="optimaalAangever"
                         style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                [label]="eersteVerdeelpost === 1 ? 'Aangever voorstel' : ''"
                                align="right"
                                class="custom-input-125"
                                formControlName="aandeelEigenWoning"
                                id="aandeelEigenWoningOA"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div formGroupName="optimaalPartner" style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                [label]="eersteVerdeelpost === 1 ? 'Partner voorstel' : ''"
                                align="right"
                                class="me-1 custom-input-125"
                                formControlName="aandeelEigenWoning"
                                id="aandeelEigenWoningOP"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div style="width: 50px;"></div>
                </form>
            </div>
        }

        @if (formGroup.controls.totaalTeVerdelen.controls.totaalBox2.value ?? 0 > 0) {
            <div class="pt-0.5 row">
                <form [formGroup]="formGroup" class="d-contents">
                    <div class="pe-2 ps-1" style="width: 300px; text-align: start">
                        <p [class]="eersteVerdeelpost == 2 ? 'pt-3' : ''">
                            Voordeel aanmerkelijk belang
                        </p>
                    </div>
                    <div class="pe-4" formGroupName="totaalTeVerdelen" style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                [label]="eersteVerdeelpost === 2 ? 'Totaal' : ''"
                                align="right"
                                class="me-1 custom-input-125"
                                formControlName="totaalBox2"
                                id="totaalBox2"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="pe-3" formGroupName="gekozenAangever" style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [label]="eersteVerdeelpost === 2 ? 'Aangever toegepast' : ''"
                                [maxValue]="formGroup.controls.totaalTeVerdelen.controls.totaalBox2.value ?? 0"
                                [minValue]="0"
                                align="right"
                                class="custom-input-125"
                                formControlName="aandeelBox2"
                                id="aandeelBox2GA"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="pe-5" formGroupName="gekozenPartner" style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [calculate]="getPartnerDeelBox2()"
                                [decimals]="0"
                                [disabledControl]="true"
                                [label]="eersteVerdeelpost === 2 ? 'Partner toegepast' : ''"
                                align="right"
                                class="me-1 custom-input-125"
                                formControlName="aandeelBox2"
                                id="aandeelBox2GP"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="ps-5 pe-3" formGroupName="optimaalAangever"
                         style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                [label]="eersteVerdeelpost === 2 ? 'Aangever voorstel' : ''"
                                align="right"
                                class="custom-input-125"
                                formControlName="aandeelBox2"
                                id="aandeelBox2OA"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div formGroupName="optimaalPartner" style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                [label]="eersteVerdeelpost === 2 ? 'Partner voorstel' : ''"
                                align="right"
                                class="me-1 custom-input-125"
                                formControlName="aandeelBox2"
                                id="aandeelBox2OP"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div style="width: 50px;"></div>
                </form>
            </div>
        }

        @if (formGroup.controls.totaalTeVerdelen.controls.totaalBox3.value ?? 0 > 0) {
            <div class="pt-0.5 row">
                <form [formGroup]="formGroup" class="d-contents">
                    <div class="pe-2 ps-1" style="width: 300px; text-align: start">
                        <p [class]="eersteVerdeelpost == 3 ? 'pt-3' : ''">
                            Grondslag sparen en beleggen
                        </p>
                    </div>
                    <div class="pe-4" formGroupName="totaalTeVerdelen" style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                [label]="eersteVerdeelpost === 3 ? 'Totaal' : ''"
                                align="right"
                                class="me-1 custom-input-125"
                                formControlName="totaalBox3"
                                id="totaalBox3"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="pe-3" formGroupName="gekozenAangever" style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [label]="eersteVerdeelpost === 3 ? 'Aangever toegepast' : ''"
                                [maxValue]="formGroup.controls.totaalTeVerdelen.controls.totaalRendementsGrondslag.value ?? 0"
                                [minValue]="0"
                                align="right"
                                class="custom-input-125"
                                formControlName="aandeelBox3"
                                id="aandeelBox3GA"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="pe-5" formGroupName="gekozenPartner" style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [calculate]="getPartnerDeelBox3()"
                                [decimals]="0"
                                [disabledControl]="true"
                                [label]="eersteVerdeelpost === 3 ? 'Partner toegepast' : ''"
                                align="right"
                                class="me-1 custom-input-125"
                                formControlName="aandeelBox3"
                                id="aandeelBox3GP"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="ps-5 pe-3" formGroupName="optimaalAangever"
                         style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                [label]="eersteVerdeelpost === 3 ? 'Aangever voorstel' : ''"
                                align="right"
                                class="custom-input-125"
                                formControlName="aandeelBox3"
                                id="aandeelBox3OA"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div formGroupName="optimaalPartner" style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                [label]="eersteVerdeelpost === 3 ? 'Partner voorstel' : ''"
                                align="right"
                                class="me-1 custom-input-125"
                                formControlName="aandeelBox3"
                                id="aandeelBox3OP"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div style="width: 50px;"></div>
                </form>
            </div>
        }

        @if (formGroup.controls.totaalTeVerdelen.controls.totaalPGA.value ?? 0 !== 0) {
            <div class="pt-0.5 row">
                <form [formGroup]="formGroup" class="d-contents">
                    <div class="pe-2 ps-1" style="width: 300px; text-align: start">
                        <p [class]="eersteVerdeelpost == 4 ? 'pt-3' : ''">
                            Persoonsgebonden aftrek
                        </p>
                    </div>
                    <div class="pe-4" formGroupName="totaalTeVerdelen" style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                [label]="eersteVerdeelpost === 4 ? 'Totaal' : ''"
                                align="right"
                                class="me-1 custom-input-125"
                                formControlName="totaalPGA"
                                id="totaalPGA"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="pe-3" formGroupName="gekozenAangever" style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [label]="eersteVerdeelpost === 4 ? 'Aangever toegepast' : ''"
                                [maxValue]="formGroup.controls.totaalTeVerdelen.controls.totaalPGA.value ?? 0"
                                [minValue]="0"
                                align="right"
                                class="custom-input-125"
                                formControlName="aandeelPGA"
                                id="aandeelPGAGA"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="pe-5" formGroupName="gekozenPartner" style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [calculate]="getPartnerDeelPga()"
                                [decimals]="0"
                                [disabledControl]="true"
                                [label]="eersteVerdeelpost === 4 ? 'Partner toegepast' : ''"
                                align="right"
                                class="me-1 custom-input-125"
                                formControlName="aandeelPGA"
                                id="aandeelPGAGP"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="ps-5 pe-3" formGroupName="optimaalAangever"
                         style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                [label]="eersteVerdeelpost === 4 ? 'Aangever voorstel' : ''"
                                align="right"
                                class="custom-input-125"
                                formControlName="aandeelPGA"
                                id="aandeelPGAOA"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div formGroupName="optimaalPartner" style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                [label]="eersteVerdeelpost === 4 ? 'Partner voorstel' : ''"
                                align="right"
                                class="me-1 custom-input-125"
                                formControlName="aandeelPGA"
                                id="aandeelPGAOP"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div style="width: 50px;"></div>
                </form>
            </div>
        }

        @if (formGroup.controls.totaalTeVerdelen.controls.totaalDividendbelasting.value ?? 0 !== 0) {
            <div class="pt-0.5 row">
                <form [formGroup]="formGroup" class="d-contents">
                    <div class="pe-2 ps-1" style="width: 300px; text-align: start">
                        <p [class]="eersteVerdeelpost == 5 ? 'pt-3' : ''">
                            Ingehouden dividendbelasting
                        </p>
                    </div>
                    <div class="pe-4" formGroupName="totaalTeVerdelen" style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                [label]="eersteVerdeelpost === 5 ? 'Totaal' : ''"
                                align="right"
                                class="me-1 custom-input-125"
                                formControlName="totaalDividendbelasting"
                                id="totaalDividendbelasting"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="pe-3" formGroupName="gekozenAangever" style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [label]="eersteVerdeelpost === 5 ? 'Aangever toegepast' : ''"
                                [maxValue]="formGroup.controls.totaalTeVerdelen.controls.totaalDividendbelasting.value ?? 0"
                                [minValue]="0"
                                align="right"
                                class="custom-input-125"
                                formControlName="aandeelDividendbelasting"
                                id="aandeelDividendbelastingGA"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="pe-5" formGroupName="gekozenPartner" style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [calculate]="getPartnerDeelDiv()"
                                [decimals]="0"
                                [disabledControl]="true"
                                [label]="eersteVerdeelpost === 5 ? 'Partner toegepast' : ''"
                                align="right"
                                class="me-1 custom-input-125"
                                formControlName="aandeelDividendbelasting"
                                id="aandeelDividendbelastingGP"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="ps-5 pe-3" formGroupName="optimaalAangever"
                         style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                [label]="eersteVerdeelpost === 5 ? 'Aangever voorstel' : ''"
                                align="right"
                                class="custom-input-125"
                                formControlName="aandeelDividendbelasting"
                                id="aandeelDividendbelastingOA"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div formGroupName="optimaalPartner" style="width: 150px; flex: 1; text-align: end;">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                [label]="eersteVerdeelpost === 5 ? 'Partner voorstel' : ''"
                                align="right"
                                class="me-1 custom-input-125"
                                formControlName="aandeelDividendbelasting"
                                id="aandeelDividendbelastingOP"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div style="width: 50px;"></div>
                </form>
            </div>
        }

        <div class="pt-0.5 row">
            <form [formGroup]="formGroup" class="d-contents">
                <div class="pe-2 ps-1" style="width: 300px; text-align: start">
                    <p><b>Verschuldigde belasting</b></p>
                </div>
                <div class="pe-4" style="width: 150px; flex: 1; text-align: end;">
                    <snelstart-ui-number-form-control
                            [calculate]="getVerschuldigdeBelasting()"
                            [decimals]="0"
                            [disabledControl]="true"
                            align="right"
                            class="me-1 custom-input-125"
                            formControlName="totaalVerschuldigdeBelastingGekozen"
                            id="totaalVerschuldigdeBelastingGekozen"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="pe-3" formGroupName="gekozenAangever" style="width: 150px; flex: 1; text-align: end;">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            [disabledControl]="true"
                            align="right"
                            class="custom-input-125"
                            formControlName="verschuldigdeBelasting"
                            id="verschuldigdeBelastingGA"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="pe-5" formGroupName="gekozenPartner" style="width: 150px; flex: 1; text-align: end;">
                    <snelstart-ui-number-form-control
                            [calculate]="getPartnerDeelDiv()"
                            [decimals]="0"
                            [disabledControl]="true"
                            align="right"
                            class="me-1 custom-input-125"
                            formControlName="verschuldigdeBelasting"
                            id="verschuldigdeBelastingGP"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="ps-5 pe-3" formGroupName="optimaalAangever" style="width: 150px; flex: 1; text-align: end;">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            [disabledControl]="true"
                            align="right"
                            class="custom-input-125"
                            formControlName="verschuldigdeBelasting"
                            id="verschuldigdeBelastingOA"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div formGroupName="optimaalPartner" style="width: 150px; flex: 1; text-align: end;">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            [disabledControl]="true"
                            align="right"
                            class="me-1 custom-input-125"
                            formControlName="verschuldigdeBelasting"
                            id="verschuldigdeBelastingOP"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div style="width: 50px;"></div>
            </form>
        </div>

        <div class="pt-3" style="width: 75%">
            @let optimaleVerdeling = getVerschuldigdeBelastingOptimaal();
            @let gekozenVerdeling = getVerschuldigdeBelasting();

            @if (gekozenVerdeling - optimaleVerdeling > 0) {
                <snelstart-ui-alert type="warning">
                    <p class="mb-0">De voorgestelde verdeling is
                        € {{ (gekozenVerdeling - optimaleVerdeling | number:'1.0-0':'nl-NL') }} voordeliger
                        dan de nu gekozen verdeling.</p>
                </snelstart-ui-alert>
            }

            @if (gekozenVerdeling - optimaleVerdeling < 0) {
                <snelstart-ui-alert type="success">
                    <p class="mb-0">Wow! De gekozen verdeling is
                        € {{ (gekozenVerdeling - optimaleVerdeling | number:'1.0-0':'nl-NL') }} voordeliger
                        beter dan de voorgestelde verdeling. Werk voor ons te doen.</p>
                </snelstart-ui-alert>
            }

            @if (gekozenVerdeling - optimaleVerdeling === 0) {
                <snelstart-ui-alert type="success">
                    <p class="mb-0">De uitkomst van de gekozen verdeling is gelijk aan de uitkomst volgens de
                        voorgestelde verdeling.</p>
                </snelstart-ui-alert>
            }
        </div>


        <!--      <div class="pt-1 row">-->
                <!--        <form (change)="saveForm()" [formGroup]="formGroup" class="d-contents">-->
                <!--          <div class="pe-2 ps-1" style="width: 300px; text-align: start">-->
                <!--            <p>Aftrek geen/kleine eigenwoningschuld</p>-->
                <!--          </div>-->
                <!--          <div class="pe-4" style="width: 150px; flex: 1; text-align: end;">-->
                <!--            <snelstart-ui-number-form-control-->
                <!--              [decimals]="0"-->
                <!--              [disabledControl]="true"-->
                <!--              align="right"-->
                <!--              class="me-1 custom-input-125 custom-readonly"-->
                <!--              formControlName="totaalGOGEWS"-->
                <!--              id="totaalGOGEWSGekozen"-->
                <!--              prefix="€"-->
                <!--            ></snelstart-ui-number-form-control>-->
                <!--          </div>-->
                <!--          <div class="pe-3" style="width: 150px; flex: 1; text-align: end;">-->
                <!--            <snelstart-ui-number-form-control-->
                <!--              [decimals]="0"-->
                <!--              [disabledControl]="true"-->
                <!--              align="right"-->
                <!--              class="custom-input-125"-->
                <!--              formControlName="aandeelGOGEWSAangever"-->
                <!--              id="aandeelGOGEWSAangeverGekozen"-->
                <!--              prefix="€"-->
                <!--            ></snelstart-ui-number-form-control>-->
                <!--          </div>-->
                <!--          <div class="pe-5" style="width: 150px; flex: 1; text-align: end;">-->
                <!--            <snelstart-ui-number-form-control-->
                <!--              [decimals]="0"-->
                <!--              [disabledControl]="true"-->
                <!--              align="right"-->
                <!--              class="me-1 custom-input-125 custom-readonly"-->
                <!--              formControlName="aandeelGOGEWSPartner"-->
                <!--              id="aandeelGOGEWSPartnerGekozen"-->
                <!--              prefix="€"-->
                <!--            ></snelstart-ui-number-form-control>-->
                <!--          </div>-->
                <!--        </form>-->
                <!--        <form [formGroup]="optimaleVerdelingFg" class="d-contents">-->
                <!--          <div class="ps-5 pe-3" style="width: 150px; flex: 1; text-align: end;">-->
                <!--            <snelstart-ui-number-form-control-->
                <!--              [decimals]="0"-->
                <!--              [disabledControl]="true"-->
                <!--              align="right"-->
                <!--              class="custom-input-125"-->
                <!--              formControlName="aandeelGOGEWSAangever"-->
                <!--              id="aandeelGOGEWSAangever"-->
                <!--              prefix="€"-->
                <!--            ></snelstart-ui-number-form-control>-->
                <!--          </div>-->
                <!--          <div style="width: 150px; flex: 1; text-align: end;">-->
                <!--            <snelstart-ui-number-form-control-->
                <!--              [decimals]="0"-->
                <!--              [disabledControl]="true"-->
                <!--              align="right"-->
                <!--              class="me-1 custom-input-125 custom-readonly"-->
                <!--              formControlName="aandeelGOGEWSPartner"-->
                <!--              id="aandeelGOGEWSPartner"-->
                <!--              prefix="€"-->
                <!--            ></snelstart-ui-number-form-control>-->
                <!--          </div>-->
                <!--          <div style="width: 50px;"></div>-->
                <!--        </form>-->
                <!--      </div>-->
                <!--    </div>-->

    } @else {
        <p>Er zijn geen verdeelposten gevonden in de aangifte.</p>
    }
} @else {
    <snelstart-ui-spinner size="medium"></snelstart-ui-spinner>
}
